import { Card, LinearProgress, TextField, Typography } from '@mui/material';
import React from 'react';
import SortableTable from '../components/SortableTable';
import useTeams from '../hooks/useTeams';

const columns = [
  {
    id: 'team_slug',
    display: 'team_name',
    route: true,
    resource: 'team',
    numeric: false,
    disablePadding: false,
    label: 'Team',
  },
  {
    id: 'domain',
    numeric: false,
    disablePadding: false,
    label: 'Domain',
  },
  {
    id: 'sub-domain',
    numeric: false,
    hide_mobile: true,
    disablePadding: false,
    label: 'Sub-Domain',
  },
  {
    id: 'total_score',
    numeric: true,
    disablePadding: false,
    label: 'Score',
  },
];

export default function TeamsPage() {
  const { items, loading } = useTeams();
  const [searchItems, setSearchItems] = React.useState([]);
  const [searchActive, setSearchActive] = React.useState(false);

  const handleInputChange = async (e) => {
    const len = e.target.value.length;
    if (e.target.value === '') {
      console.log('clear input', e.target.value);
      setSearchActive(false);
      setSearchItems([]);
    }
    if (len > 1) {
      setSearchActive(true);
      console.log('search:', e.target.value);
      const filtered = items.filter(
        (i) =>
          i.team_name.toLowerCase().indexOf(e.target.value.toLowerCase()) >= 0
      );
      console.log({ filtered });
      setSearchItems(filtered);
    }
  };

  return (
    <span>
      <Typography variant="h6" component="h1" sx={{ p: 1.5 }}>
        Teams ({items.length})
      </Typography>
      <Card style={{ padding: '0px' }} variant="outlined" sx={{ padding: 2 }}>
        <form noValidate autoComplete="off">
          <TextField
            size="small"
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'space-around',
            }}
            id="outlined-search"
            label="Filter teams"
            type="search"
            variant="outlined"
            onChange={handleInputChange}
          />
        </form>
        {loading ? (
          <span>
            <LinearProgress />
            loading...
          </span>
        ) : (
          ''
        )}
        {searchItems?.length > 0 && (
          <span>
            <SortableTable id="teams" rows={searchItems} columns={columns} />
          </span>
        )}
        {searchActive && searchItems?.length === 0 && (
          <div>No search results</div>
        )}
        {!searchActive ? (
          <SortableTable id="teams" rows={items} columns={columns} />
        ) : null}
      </Card>
    </span>
  );
}
